import { FunctionComponent } from "react";
import { StyledActualLine, StyledLine, StyledText } from "./line.styles";

interface LineProps {
  text?: string;
}

const Line: FunctionComponent<LineProps> = ({ text }) => {
  return (
    <StyledLine>
      <StyledActualLine />
      {text && <StyledText>{text}</StyledText>}
      <StyledActualLine />
    </StyledLine>
  );
};

export default Line;
